<template>
  <div id="app-council">
    <div class="council-box">
      <div class="list-box" v-for="(item,index) in data" :key="index">
        <div class="list-l">
          <img src="../../assets/images/council.png" alt>
          <div class="info-box">
            <h5>
              <span>{{item.name}}</span>
              <i>先生</i> 理事长
            </h5>
            <ul>
              <li v-for="(item1,index1) in item.deedList" :key="index1">{{item1.title}}</li>
            </ul>
          </div>
        </div>
        <div class="list-r">
          <router-link to="/councilDetails">
            <h5>更多</h5>
            <p>more</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [
        {
          name: "张跃文",
          deedList: [
            {
              id: 1,
              title: "- 第九届中国设计业青年百人榜获奖者并颁发证书"
            },
            {
              id: 1,
              title: "-  Adobe TOP领航者之一  并颁发证书"
            },
            {
              id: 1,
              title: "-  作品收录意大利全国工业设计协会丛书中"
            },
            {
              id: 1,
              title: "-  作品收录意大利全国工业设计协会丛书中"
            }
          ]
        },
        {
          name: "张跃文",
          deedList: [
            {
              id: 1,
              title: "- 第九届中国设计业青年百人榜获奖者并颁发证书"
            },
            {
              id: 1,
              title: "-  Adobe TOP领航者之一  并颁发证书"
            },
            {
              id: 1,
              title: "-  作品收录意大利全国工业设计协会丛书中"
            },
            {
              id: 1,
              title: "-  作品收录意大利全国工业设计协会丛书中"
            }
          ]
        },
        {
          name: "张跃文",
          deedList: [
            {
              id: 1,
              title: "- 第九届中国设计业青年百人榜获奖者并颁发证书"
            },
            {
              id: 1,
              title: "-  Adobe TOP领航者之一  并颁发证书"
            },
            {
              id: 1,
              title: "-  作品收录意大利全国工业设计协会丛书中"
            },
            {
              id: 1,
              title: "-  作品收录意大利全国工业设计协会丛书中"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#app-council {
  width: 100%;
  margin: 37px 0;
}
.council-box {
  width: 1300px;
  margin: 0 auto;
  .list-box {
    padding: 15px 17px;
    margin-bottom: 52px;
    display: flex;
    justify-content: space-between;
    transition: ease-in 0.6s;
    &:hover {
      transition: all 1.5s;
      background-color: #c30d23;
      box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
      .list-l {
        .info-box {
          > h5 {
            color: #fff;
            > span {
              color: #fff;
            }
            > i {
              color: #fff;
            }
          }
          > ul {
            > li {
              color: #fff;
            }
          }
        }
      }
      .list-r {
        > a {
          > h5 {
            color: #fff;
          }
          > p {
            color: #fff;
          }
        }
      }
    }
    .list-l {
      display: flex;
      > img {
        width: 360px;
        height: 200px;
        margin-right: 58px;
      }
      .info-box {
        > h5 {
          font-size: 16px;
          color: #999999;
          font-weight: normal;
          > span {
            font-size: 24px;
            color: #333;
            font-weight: 700;
            padding-right: 5px;
          }
          > i {
            font-style: normal;
            font-size: 16px;
            color: #999999;
            padding-right: 20px;
          }
        }
        > ul {
          margin-top: 39px;
          > li {
            list-style: none;
            font-size: 14px;
            color: #333333;
            margin-bottom: 12px;
          }
        }
      }
    }
    .list-r {
      width: 61px;
      margin: 70px 0;
      border-left: 1px solid #eee;
      > a {
        > h5 {
          font-size: 14px;
          color: #333;
          font-weight: normal;
          text-align: center;
          padding-top: 13px;
        }
        > p {
          font-size: 14px;
          color: #333;
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About/about_council.vue